import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Popover from "@material-ui/core/Popover";
import InputBase from "@material-ui/core/InputBase";
import TextField from "@material-ui/core/TextField";
import Collapse from "@material-ui/core/Collapse";
import TuneIcon from "@material-ui/icons/Tune";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import MenuItem from "@material-ui/core/MenuItem";
import BuildIcon from "@material-ui/icons/BuildOutlined";
import HeadsetIcon from "@material-ui/icons/HeadsetMicOutlined";
import AddIcon from "@material-ui/icons/AddRounded";
import CloseIcon from "@material-ui/icons/CloseRounded";
import SearchIcon from "@material-ui/icons/SearchRounded";
import TableIcon from "@material-ui/icons/TableChartOutlined";
import MailIcon from "@material-ui/icons/MailOutlineRounded";
import SmsIcon from "@material-ui/icons/SmsOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import clsx from "clsx";

import { useMenuStyles } from "../../components/menuStyles";

// Aba "Ferramentas" do agente: lista ÚNICA das ferramentas que o agente usa +
// botão "Adicionar ferramenta" que abre um menu (padrão do projeto) com busca,
// mostrando só as que ainda não estão em uso. A built-in "Transferir para
// humano" (Numera Atende) entra no mesmo esquema.
const ATENDE = "__atende__";

// FERRAMENTAS DE SISTEMA (STU-179): prontas — o usuário só liga e configura. A IA
// nunca escolhe o destinatário: SMS/WhatsApp vão para a pessoa da conversa e o
// e-mail para o destino fixo daqui. Salvas em triggerConfig.systemTools.
const SYS = "sys:";
const SYSTEM_TOOLS = [
  { key: "consultar_tabela", name: "Consultar tabela", icon: TableIcon,
    description: "Busca registros nas tabelas internas que você escolher (só leitura)." },
  { key: "enviar_email_contato", name: "Enviar e-mail para a pessoa da conversa", icon: MailIcon,
    description: "Manda um e-mail para o e-mail da pessoa, informado pelo fluxo numa entrada do agente. A IA só escreve assunto e mensagem." },
  { key: "enviar_email", name: "Enviar e-mail para destinatário", icon: MailIcon,
    description: "Manda um e-mail para um destinatário fixo (ex.: sua equipe). A IA só escreve assunto e mensagem." },
  { key: "enviar_sms", name: "Enviar SMS", icon: SmsIcon,
    description: "Manda um SMS para a pessoa com quem o agente está conversando (nunca para outro número)." },
  { key: "enviar_whatsapp", name: "Enviar WhatsApp", icon: WhatsAppIcon,
    description: "Manda uma mensagem de WhatsApp para a pessoa da conversa, pela conexão escolhida (ex.: durante uma ligação)." },
];
const sysEntry = (list, key) => (Array.isArray(list) ? list : []).find(t => t && t.key === key);

const useStyles = makeStyles(theme => {
  const a = theme.app;
  return {
    head: { display: "flex", alignItems: "flex-start", gap: 16, marginBottom: 14 },
    headText: { flex: 1, minWidth: 0 },
    title: { fontSize: 12.5, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", color: a.textSecondary },
    desc: { fontSize: 13.5, color: a.textTertiary, marginTop: 6, lineHeight: 1.5 },
    addBtn: {
      flexShrink: 0, textTransform: "none", fontSize: 13, fontWeight: 600, color: "#fff", background: a.dark,
      borderRadius: 8, padding: "8px 16px", boxShadow: "none", "& svg": { fontSize: 18 },
      "&:hover": { background: a.ink, boxShadow: "none" },
      "&.Mui-disabled": { background: a.border, color: a.textTertiary },
    },

    list: { display: "flex", flexDirection: "column", gap: 8 },
    card: { display: "flex", alignItems: "center", gap: 14, background: "#fff", border: `1px solid ${a.border}`, borderRadius: 12, padding: "12px 12px 12px 16px" },
    ic: { width: 34, height: 34, borderRadius: 9, flexShrink: 0, background: "#EFF8D6", display: "flex", alignItems: "center", justifyContent: "center", "& svg": { fontSize: 18, color: "#5f7a12" } },
    main: { flex: 1, minWidth: 0 },
    name: { fontSize: 14, color: a.ink, fontWeight: 600 },
    cardDesc: { fontSize: 12.5, color: a.textTertiary, marginTop: 2, lineHeight: 1.45 },
    rm: { color: a.textTertiary, "&:hover": { color: a.danger || "#C0453B" } },

    empty: {
      background: "#fff", border: `1px dashed ${a.borderInput}`, borderRadius: 12, padding: "34px 20px", textAlign: "center",
      color: a.textTertiary, fontSize: 13.5, lineHeight: 1.5,
    },
    emptyIc: { width: 44, height: 44, borderRadius: 999, background: a.lineSoft, display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 10, "& svg": { fontSize: 21, color: a.textTertiary } },
    emptyBtn: { marginTop: 14 },

    // menu de adicionar
    pop: { width: 380, maxWidth: "calc(100vw - 32px)" },
    search: { display: "flex", alignItems: "center", gap: 6, margin: "2px 2px 6px", padding: "5px 10px", border: `1px solid ${a.borderInput}`, borderRadius: 8, "& svg": { fontSize: 17, color: a.textTertiary } },
    searchInput: { fontSize: 13, flex: 1 },
    menuList: { maxHeight: 340, overflowY: "auto" },
    menuItem: { display: "flex", alignItems: "flex-start", cursor: "pointer" },
    menuItemOff: { cursor: "default", opacity: 0.55, "&:hover": { background: "transparent" } },
    menuMain: { flex: 1, minWidth: 0 },
    menuName: { fontSize: 13, fontWeight: 600, color: a.ink },
    menuDesc: { fontSize: 11.5, color: a.textTertiary, marginTop: 2, lineHeight: 1.4, fontWeight: 400, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" },
    menuEmpty: { fontSize: 12.5, color: a.textTertiary, padding: "10px 10px" },
    link: { color: a.green, cursor: "pointer", fontWeight: 600 },
    createItem: { color: a.green, fontWeight: 600, "& svg": { color: a.green } },
    menuGroup: { fontSize: 10.5, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", color: a.textTertiary, padding: "8px 10px 4px" },

    // config de uma ferramenta de sistema (dentro do cartão)
    sysCard: { flexDirection: "column", alignItems: "stretch", gap: 0 },
    sysTop: { display: "flex", alignItems: "center", gap: 14 },
    sysCfg: { marginTop: 12, paddingTop: 12, borderTop: `1px solid ${a.lineSoft || a.border}`, display: "flex", flexDirection: "column", gap: 10 },
    sysRow: { display: "flex", gap: 10, flexWrap: "wrap", "& > *": { flex: "1 1 220px" } },
    // "Avançado (opcional)": mesmo toggle do painel de configuração do nó (ConfigDrawer)
    advToggle: {
      display: "flex", alignItems: "center", gap: 6, cursor: "pointer", userSelect: "none",
      color: a.textSecondary, fontSize: 12.5, fontWeight: 600, "& svg": { fontSize: 16 },
    },
    advBody: { display: "flex", flexDirection: "column", gap: 10, paddingTop: 10 },
    sysNote: { fontSize: 12, color: a.textTertiary, lineHeight: 1.45 },
    sysWarn: { fontSize: 12, color: "#9a6a00", lineHeight: 1.45 },
  };
});

const AgentToolsPicker = ({
  tools = [], toolIds = [], onToggleTool, transferToHuman, onTransferToHuman, atendeAvailable, disabled,
  systemTools = [], onSystemTools, datasets = [], connectors = [], inputs = [],
}) => {
  const classes = useStyles();
  const m = useMenuStyles();
  const history = useHistory();
  const [anchor, setAnchor] = useState(null);
  const [q, setQ] = useState("");
  const [more, setMore] = useState({}); // "Avançado (opcional)" aberto, por ferramenta de sistema

  const atendeItem = {
    id: ATENDE,
    name: "Transferir para humano (Numera Atende)",
    description: "Passa a conversa de WhatsApp para um atendente quando o cliente pedir uma pessoa (ou quando a IA não resolver).",
    builtin: true,
    off: !atendeAvailable,
  };
  const sysItems = SYSTEM_TOOLS.map(t => ({ ...t, id: SYS + t.key, builtin: true, system: true }));
  const isUsed = t => {
    if (t.id === ATENDE) return transferToHuman === true;
    if (t.system) return !!sysEntry(systemTools, t.key);
    return toolIds.includes(t.id);
  };
  const all = [...tools, ...sysItems, atendeItem];
  const used = all.filter(isUsed);
  const term = q.trim().toLowerCase();
  const available = all
    .filter(t => !isUsed(t))
    .filter(t => !term || `${t.name} ${t.description || ""}`.toLowerCase().includes(term));

  const setSys = (key, patch) => {
    const list = Array.isArray(systemTools) ? systemTools : [];
    if (patch === null) onSystemTools(list.filter(x => x && x.key !== key));
    else if (sysEntry(list, key)) onSystemTools(list.map(x => (x && x.key === key ? { ...x, ...patch } : x)));
    else onSystemTools([...list, { key, ...patch }]);
  };
  const toggle = t => {
    if (t.id === ATENDE) onTransferToHuman(!transferToHuman);
    else if (t.system) setSys(t.key, isUsed(t) ? null : {});
    else onToggleTool(t.id);
  };
  const m2 = { MenuProps: { classes: { paper: m.selectPaper } } };
  const waConns = connectors.filter(c => c.type === "whatsapp_qr");
  const smtpConns = connectors.filter(c => c.type === "smtp");

  // campos de configuração de cada ferramenta de sistema
  const sysConfig = t => {
    const e = sysEntry(systemTools, t.key) || {};
    if (t.key === "consultar_tabela") {
      const ids = (e.datasetIds || []).map(Number);
      return (
        <>
          <TextField select fullWidth variant="outlined" size="small" label="Tabelas que o agente pode consultar" disabled={disabled}
            value={ids} onChange={ev => setSys(t.key, { datasetIds: ev.target.value })}
            SelectProps={{ ...m2, multiple: true, renderValue: v => datasets.filter(d => v.includes(d.id)).map(d => d.name).join(", ") }}>
            {datasets.length === 0 ? <MenuItem disabled value="">Nenhuma tabela na conta</MenuItem> : null}
            {datasets.map(d => <MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>)}
          </TextField>
          {ids.length === 0 ? <div className={classes.sysWarn}>Escolha ao menos uma tabela — sem isso a ferramenta não fica disponível para a IA.</div> : null}
        </>
      );
    }
    if (t.key === "enviar_email" || t.key === "enviar_email_contato") {
      const toContact = t.key === "enviar_email_contato";
      const inputNames = (inputs || []).map(i => i && i.name).filter(Boolean);
      const filled = !!(e.connectorId || e.fromName || e.fromEmail || e.replyTo);
      const open = more[t.key] != null ? more[t.key] : filled;
      return (
        <>
          {toContact ? (
            <TextField select fullWidth variant="outlined" size="small" label="Entrada com o e-mail da pessoa" disabled={disabled} SelectProps={m2}
              value={e.input || ""} onChange={ev => setSys(t.key, { input: ev.target.value })}>
              {inputNames.length === 0 ? <MenuItem disabled value="">O agente não tem entradas</MenuItem> : null}
              {inputNames.map(n => <MenuItem key={n} value={n}>{n}</MenuItem>)}
            </TextField>
          ) : (
            <TextField fullWidth variant="outlined" size="small" label="Enviar para" placeholder="equipe@empresa.com.br" disabled={disabled}
              value={e.to || ""} onChange={ev => setSys(t.key, { to: ev.target.value })} />
          )}
          {toContact
            ? (!e.input
              ? <div className={classes.sysWarn}>{inputNames.length ? "Escolha a entrada que traz o e-mail." : "Crie uma entrada (ex.: email) em Geral › Entradas e preencha no fluxo que chama o agente."}</div>
              : <div className={classes.sysNote}>O e-mail vai para o valor da entrada "{e.input}" que o fluxo informar. Sem esse valor, a IA avisa a pessoa que não dá para enviar.</div>)
            : (!String(e.to || "").trim()
              ? <div className={classes.sysWarn}>Informe o destinatário — a IA não escolhe para quem envia.</div>
              : <div className={classes.sysNote}>A IA só escreve o assunto e a mensagem; o e-mail vai sempre para este endereço.</div>)}
          <div>
            <div className={classes.advToggle} onClick={() => setMore(x => ({ ...x, [t.key]: !open }))}>
              <TuneIcon />
              Avançado (opcional)
              {open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
            </div>
            <Collapse in={open}>
              <div className={classes.advBody}>
              <div className={classes.sysRow}>
                <TextField select variant="outlined" size="small" label="Enviar por" disabled={disabled}
                  SelectProps={{ ...m2, displayEmpty: true }} InputLabelProps={{ shrink: true }}
                  value={e.connectorId || ""} onChange={ev => setSys(t.key, { connectorId: ev.target.value || null })}>
                  <MenuItem value="">Numera (padrão)</MenuItem>
                  {smtpConns.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
                </TextField>
                <TextField variant="outlined" size="small" label="Nome do remetente" placeholder="Sua Empresa" disabled={disabled}
                  value={e.fromName || ""} onChange={ev => setSys(t.key, { fromName: ev.target.value })} />
              </div>
              <div className={classes.sysRow}>
                <TextField variant="outlined" size="small" label="E-mail do remetente" placeholder="no-reply@numeramail.com.br" disabled={disabled}
                  helperText="Pela Numera, só endereços do domínio verificado."
                  value={e.fromEmail || ""} onChange={ev => setSys(t.key, { fromEmail: ev.target.value })} />
                <TextField variant="outlined" size="small" label="Responder para" placeholder="contato@suaempresa.com.br" disabled={disabled}
                  helperText="Para onde vão as respostas."
                  value={e.replyTo || ""} onChange={ev => setSys(t.key, { replyTo: ev.target.value })} />
              </div>
              </div>
            </Collapse>
          </div>
        </>
      );
    }
    if (t.key === "enviar_sms") {
      return <div className={classes.sysNote}>Vai para o número da pessoa da conversa (ligação ou WhatsApp). Não funciona no teste pelo painel.</div>;
    }
    if (t.key === "enviar_whatsapp") {
      return (
        <>
          <TextField select fullWidth variant="outlined" size="small" label="Conexão do WhatsApp" disabled={disabled} SelectProps={m2}
            value={e.connectorId || ""} onChange={ev => setSys(t.key, { connectorId: ev.target.value || null })}>
            {waConns.length === 0 ? <MenuItem disabled value="">Nenhuma conexão de WhatsApp</MenuItem> : null}
            {waConns.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
          </TextField>
          {!e.connectorId ? (
            <div className={classes.sysWarn}>
              Escolha a conexão.{waConns.length === 0 ? <> <span className={classes.link} onClick={() => history.push("/connectors")}>Conectar WhatsApp →</span></> : null}
            </div>
          ) : <div className={classes.sysNote}>Vai para o número da pessoa da conversa.</div>}
        </>
      );
    }
    return null;
  };
  const add = t => {
    if (t.off) return;
    toggle(t);
    setAnchor(null);
    setQ("");
  };

  const addButton = extraCls => (
    <Button className={clsx(classes.addBtn, extraCls)} startIcon={<AddIcon />} disabled={disabled} onClick={e => setAnchor(e.currentTarget)}>
      Adicionar ferramenta
    </Button>
  );

  return (
    <div>
      <div className={classes.head}>
        <div className={classes.headText}>
          <div className={classes.title}>Ferramentas do agente</div>
          <div className={classes.desc}>O que o agente pode consultar ou executar durante a conversa.</div>
        </div>
        {used.length > 0 && addButton()}
      </div>

      {used.length === 0 ? (
        <div className={classes.empty}>
          <div className={classes.emptyIc}><BuildIcon /></div>
          <div>O agente ainda não usa nenhuma ferramenta.</div>
          {addButton(classes.emptyBtn)}
        </div>
      ) : (
        <div className={classes.list}>
          {used.map(t => {
            const Ic = t.icon || (t.builtin ? HeadsetIcon : BuildIcon);
            const top = (
              <>
                <span className={classes.ic}><Ic /></span>
                <div className={classes.main}>
                  <div className={classes.name}>{t.name}</div>
                  {t.description ? <div className={classes.cardDesc}>{t.description}</div> : null}
                </div>
                <Tooltip title="Tirar do agente">
                  <span>
                    <IconButton size="small" className={classes.rm} disabled={disabled} onClick={() => toggle(t)}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
              </>
            );
            return t.system ? (
              <div key={t.id} className={clsx(classes.card, classes.sysCard)}>
                <div className={classes.sysTop}>{top}</div>
                <div className={classes.sysCfg}>{sysConfig(t)}</div>
              </div>
            ) : (
              <div key={t.id} className={classes.card}>{top}</div>
            );
          })}
        </div>
      )}

      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => { setAnchor(null); setQ(""); }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ className: clsx(m.paper, classes.pop) }}
      >
        <div className={classes.search}>
          <SearchIcon />
          <InputBase autoFocus className={classes.searchInput} placeholder="Buscar ferramenta" value={q} onChange={e => setQ(e.target.value)} />
        </div>
        <div className={classes.menuList}>
          {available.length === 0 ? (
            <div className={classes.menuEmpty}>{term ? "Nenhuma ferramenta encontrada." : "Todas as ferramentas já estão em uso."}</div>
          ) : (
            available.map((t, i) => {
              const Ic = t.icon || (t.builtin ? HeadsetIcon : BuildIcon);
              const prev = available[i - 1];
              const group = t.builtin && (!prev || !prev.builtin) ? <div className={classes.menuGroup}>Prontas do sistema</div> : null;
              return (
              <React.Fragment key={t.id}>
              {group}
              <div className={clsx(m.item, classes.menuItem, t.off && classes.menuItemOff)} onClick={() => add(t)}>
                <Ic />
                <div className={classes.menuMain}>
                  <div className={classes.menuName}>{t.name}</div>
                  <div className={classes.menuDesc}>
                    {t.off ? (
                      <>Requer o conector Numera Atende.{" "}
                        <span className={classes.link} onClick={e => { e.stopPropagation(); history.push("/connectors"); }}>Conectar →</span>
                      </>
                    ) : t.description}
                  </div>
                </div>
              </div>
              </React.Fragment>
              );
            })
          )}
        </div>
        <div className={m.divider} />
        <div className={clsx(m.item, classes.menuItem, classes.createItem)} onClick={() => history.push("/agents/tools")}>
          <AddIcon /> Criar nova ferramenta
        </div>
      </Popover>
    </div>
  );
};

export default AgentToolsPicker;
